module.exports = __webpack_public_path__ + "img/se.c3360ca2.svg";